export const textGeometries = new Map()
export const materials = {
  seat: {}, // would be better to rename to meshBasic or mesh
  line: {}
}
export const seats = {}
export const standingAreas = []
export const blocks = []
